import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { getCurrentUser } from './store/selectors'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import { ThemeProvider } from '@material-ui/core'

import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl'
import { load, loadMessages } from '@progress/kendo-react-intl'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import localCurrency from 'cldr-numbers-full/main/de/currencies.json'
import numbers from 'cldr-numbers-full/main/de/numbers.json'
import caGregorian from 'cldr-dates-full/main/de/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/de/dateFields.json'
import messages from './messages.json'

import { Header, Footer } from './layout'
import { BBraunTheme } from './theme'
import { Search, ProjectDialog, Languages, Login, PrintRFQ, PrintOrder, Users } from './pages'
import { getIsLoggedIn } from './store/selectors'
import { ToastContainer } from './components/common/Toast'

dateFields.main.de.dates.fields.day.displayName = '__'
dateFields.main.de.dates.fields.month.displayName = '__'
dateFields.main.de.dates.fields.year.displayName = '____'

load(
    likelySubtags,
    currencyData,
    weekData,
    localCurrency,
    numbers,
    caGregorian,
    dateFields,
)
loadMessages(messages, 'de')

export default () => {
    const isLoggedIn = useSelector(getIsLoggedIn)
    const userIsApplicationOwner = useSelector(getCurrentUser).isApplicationOwner

    if (!isLoggedIn) {
        /*
        * undefined -> login in progress
        * true -> logged in
        * false -> login failed
        * */
        return <Fragment>
            <ToastContainer />
            <Login/>
        </Fragment>
    }
    return (isLoggedIn &&
        <LocalizationProvider language="de">
            <IntlProvider locale="de">
                <ToastContainer />
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/print/rfq">
                            <PrintRFQ/>
                        </Route>
                        <Route exact path="/print/order">
                            <PrintOrder/>
                        </Route>
                        <Route>
                            <ThemeProvider theme={BBraunTheme}>
                                <Header/>
                                <Content>
                                    <Route path="/" exact component={Search}/>
                                    <Route path="/edit/:projectId" exact component={ProjectDialog}/>
                                    {userIsApplicationOwner && <Route path="/users" component={Users}/>}
                                    {userIsApplicationOwner && <Route path="/languages" component={Languages}/>}
                                </Content>
                                <Footer/>
                            </ThemeProvider>
                        </Route>
                    </Switch>
                </BrowserRouter>
            </IntlProvider>
        </LocalizationProvider>
    )
}

const Content = styled.div`
    display: block;
    flex: 1;
    margin: 20px 40px;
`



// WEBPACK FOOTER //
// ./src/App.js